import React from 'react'
import { Flex } from '@chakra-ui/react'
import { motion } from 'framer-motion'
import RotateAnimation from './RotateAnimation'

const LoaderAnimation = () => {
    const text = "Chetas Sharma"
    const textArr = text.split('')
    const Obj = textArr.map((letter,idx) => {
        return <RotateAnimation delayTime={idx/3}>{letter}</RotateAnimation>
    })
    return (
        <motion.div
            key="loader"
            initial={{ opacity: 1 }}
            animate={{ opacity: 1}}
            exit={{ opacity: 0}}
        >
            <Flex justifyContent="center" alignItems="center">
                {Obj}
            </Flex>
        </motion.div>
    )
}

export default LoaderAnimation
